import styled, { css } from 'styled-components'

import { Skeleton } from '@blade/ui-kit'

export const PairReusedSkeleton: React.FC = () => {
  return (
    <Root>
      <Content>
        <Main>
          <Icon>
            <Skeleton variant="rectangle" width={39} height={39} />
          </Icon>
          <Body>
            <Row>
              <Skeleton width={52} height={8} />
              <Skeleton width={64} height={8} />
            </Row>
            <Row $single>
              <Skeleton width={72} height={8} />
            </Row>
            <Row>
              <Skeleton width={88} height={8} />
              <Skeleton width={28} height={8} />
            </Row>
          </Body>
        </Main>
      </Content>
    </Root>
  )
}

const Root = styled.div`
  border-radius: 7px;
  padding: 1px;
`

const Content = styled.div`
  border-radius: 6px;
  background: var(--background-4);
  backdrop-filter: blur(1.5px);
`

const Main = styled.div`
  display: grid;
  grid-template-columns: 39px minmax(0, 1fr);
  column-gap: 8px;
  align-items: start;
  padding: 7px 7px 6px;
`

const Icon = styled.div`
  grid-row: 1 / -1;
  align-self: start;
`

const Body = styled.div`
  display: grid;
  gap: 5px;
  min-width: 0;
`

const Row = styled.div<{ $single?: boolean }>`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 4px;
  align-items: center;

  ${({ $single }) =>
    $single &&
    css`
      grid-template-columns: minmax(0, 1fr);
    `}
`
